export default __webpack_public_path__ + "media/images/evangelion/evangelion-3f8ab6c6083636df2acfa96a64d5e996.jpg";